import moment from "moment";
import { formats as FORMATS } from "../../config/constants";
import SingleSelectComponent from "../single-select/single-select.component";

/**
 * QuarterPickerComponent
 * 
 * This is a year-quarter picker component based on `SingleSelectComponent`.
 * 
 * @author CV Leong 
 */
export default function QuarterPickerComponent() {

  const DEFAULT_MAX = moment().add(100, 'years').format(FORMATS.API_QUARTER_FORMAT);
  const DEFAULT_MIN = moment().subtract(100, 'years').format(FORMATS.API_QUARTER_FORMAT);

  return {
    view: ({ attrs: {
      max = DEFAULT_MAX,
      min = DEFAULT_MIN,
      ...otherAttrs
    } }) => {
      return [
        m(SingleSelectComponent, {
          allowEmpty: false,
          triggerAttrs: {
            style: { 'min-width': '4rem' },
          },
          keyOnly: true,
          ...otherAttrs,
          // prevent override
          items: renderYearQuarterOptions(min, max),
        }),
      ]
    }
  }
}

/**
 * Generates an option list for `QuarterPickerComponent`.
 * @param {Number} min - The minimum year-quarter (YYYYQ) allowed. E.g. 20192.
 * @param {Number} max - The maximum year-quarter (YYYYQ) allowed. E.g. 20192.
 * @returns Returns an array of year-quarter options. E.g. `[{ code: '20241', name: '2024Q1' }]`
 */
const renderYearQuarterOptions = (min, max) => {

  const maxQuarter = moment(max, FORMATS.API_QUARTER_FORMAT);
  const minQuarter = moment(min, FORMATS.API_QUARTER_FORMAT);
  const options = [];

  let currentQuarter = maxQuarter;

  while (currentQuarter.isBetween(minQuarter, maxQuarter, 'Q', '[]')) {
    options.push({
      code: currentQuarter.format(FORMATS.API_QUARTER_FORMAT),
      name: currentQuarter.format(FORMATS.QUARTER_FORMAT),
    });

    currentQuarter = currentQuarter.subtract(1, 'Q');
  }

  return options;
}
